import { asString, isRecord } from '../cellValues';
export const asIdentity = (value)=>{
    if (!isRecord(value)) return undefined;
    const name = asString(value.name);
    if (name == null) return undefined;
    const count = typeof value.count === 'number' ? value.count : undefined;
    return {
        name,
        email: asString(value.email),
        avatarUrl: asString(value.avatarUrl),
        initials: asString(value.initials),
        count
    };
};
